import moment from 'moment'
export default {
  name: 'chat',
  props: ['isChatVisible'],
  data: function () {
    return {
      messages: [],
      userMessage: '',
      webSocketSession: null,
      userId: this.$store.state.userInfo.id,
      customerId: this.$store.state.userInfo.customer.id,
      messageId: 0
    }
  },
  methods: {
    activateChat () {
      const self = this
      this.$store.state.webSocket.on('socket/connect', function (session) {
        self.webSocketSession = session
        self.webSocketSession.subscribe(
          `api/ws/chat/customer/${self.customerId}`,
          function (uri, payload) {
            if (payload.msgs) {
              payload.msgs.forEach(function (msg) {
                self.setMessage(msg)
              })
            } else if (payload.msg) {
              self.setMessage(payload)
            }
          }
        )
      })
    },
    sendMessage () {
      const self = this
      const message = this.userMessage
      if (!this.userMessage || message.trim().length === 0) {
        return
      }
      this.webSocketSession.publish(
        `api/ws/chat/customer/${self.customerId}`,
        this.userMessage
      )
      this.userMessage = ''
    },
    setMessage (message) {
      const msg = {
        isUserMessage: message.user.id === this.userId,
        title: `${message.user.firstname} ${message.user.lastname}`,
        body: message.msg,
        time:
          moment()
            .startOf('day')
            .diff(moment(message.datetime).startOf('day'), 'days') > 0
            ? moment(message.datetime).format('DD MMM HH:mm')
            : moment(message.datetime).format('HH:mm'),
        id: this.messageId++
      }
      this.messages.push(msg)
      if (
        !this.isChatVisible &&
        moment(message.datetime).diff(
          moment(this.$store.state.appSettings.chatLastVisitTime)
        ) > 0
      ) {
        this.$eventBus.$emit('addUnreadedChatMessage')
      }
    },
    scrollToEnd () {
      const container = this.$el.querySelector('.chat-messages')
      container.scrollTop = container.scrollHeight
    }
  },
  created () {
    this.activateChat()
  },
  updated () {
    this.scrollToEnd()
  },
  mounted () {
    this.$eventBus.$on('onShowChatView', () => {
      this.$nextTick(function () {
        this.scrollToEnd()
      })
    })
  }
}
